// const def = {
//     "name": "Kortrijk",
//     "coordinates": "50.814933, 3.258840",
//     "GroundResults": ["recMIXZ3CXqkwxIhn"]
// }

const state = {
    location :  {},
    locationArray : []
};

// context.state =local state, and root state = context.rootState:

const getters = {
    getLocation: state => {
        return state.location;
    },
    'getCityName': state => {
        return state.location.name;
    },
    getNetworks: state => {
        return state.location.GroundResults;
    }
};

const mutations = { 
    setLocation (state, location) {
        state.location = location;
    }
};

const actions ={
    // setData (context) {
    //     context.commit('')
    // }
}

export default {
    state,
    getters,
    mutations,
}